import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { NavLink } from 'react-router-dom';
import idProtectionImage from '../images/homeimge.jpg'; // Replace with actual image path
import Navbar from '../components/Navbar';
// import unseenbgimg from '../images/unseenbgimg.png'

function Contact() {
  return (
    <Box>
      <Navbar />

      {/* Hero Section */}
      <Box
        sx={{
          height: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${idProtectionImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#ffffff',
          position: 'relative',
          textAlign: 'center',
          mb: 4,
        }}
      >
        {/* Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          }}
        />

        {/* Content */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >


          {/* Title */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.5rem', md: '3rem' },
              fontWeight: 'bold',
              marginBottom: '1rem',
              fontFamily: 'Georgia, serif',
            }}
          >
            Contact Us
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: { xs: '1rem', md: '1.2rem' },
              fontWeight: 300,
            }}
          >
            Unseen Knuckles Eco Boutique
          </Typography>

          {/* Divider Line */}
          <Box
            sx={{
              width: '50px',
              height: '2px',
              backgroundColor: 'white',
              mt: 2,
            }}
          />
        </Box>
      </Box>

      {/* Contact Information and Map Section */}
      <Box sx={{ backgroundColor: 'white', py: 6 }}>
        <Container>
          <Grid container spacing={4}>
            {/* Embedded Google Map */}
            <Grid item xs={12} md={6}>
              <Box
                component="iframe"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63304.090774753975!2d80.70130485971323!3d7.409148170688156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae35f3d0f4f9585%3A0xe3df8738ec190592!2sThawalanthenna!5e0!3m2!1sen!2slk!4v1733673478504!5m2!1sen!2slk"
                width="100%"
                height="390px"
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"
                sx={{
                  border: '1px solid #333',
                  borderRadius: '8px',
                }}
              />
            </Grid>

            {/* Contact Information */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  color: '#ffffff',
                  border: '1px solid #333',
                  borderRadius: '8px',
                  p: 4,
                  // backgroundColor: 'black',
                  textAlign: "center",
                  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), 
      url(${idProtectionImage})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
                }}
              >
                {/* Reservation Details */}
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      color: 'white',
                      mb: 1,
                    }}
                  >
                    Reservation
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: '1rem', mb: 1, color: 'gold' }}>
                    Email: <span style={{ color: 'white' }}>info@unseen.travel</span>
                  </Typography>
                  
                  <Typography variant="body1" sx={{ fontSize: '1rem', mb: 1, color: 'gold' }}>
                    Call: <span style={{ color: 'white' }}>+94776718674</span>
                  </Typography>
                </Box>

                {/* Hotel Address */}
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      color: 'white',
                      mb: 1,
                    }}
                  >
                    Hotel Address
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: '1rem', mb: 1, color: 'gold' }}>
                  Unseen Knuckles Eco Boutique
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: '1rem', color: 'gold' }}>
                  Number 969, knuckles Estate, Thawalanthanna, Sri Lanka
                  </Typography>
                </Box>

                {/* Social Links */}
                <Box sx={{ mt: 4, display: 'flex', gap: 3, justifyContent: 'center' }}>
                  <Typography
                    component="a"
                    href="#"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '1.5rem',
                      '&:hover': { color: 'gold' },

                    }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Typography>
                  <Typography
                    component="a"
                    href="#"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '1.5rem',
                      '&:hover': { color: 'gold' },
                    }}
                  >
                    <i className="fab fa-twitter"></i>
                  </Typography>
                  <Typography
                    component="a"
                    href="#"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '1.5rem',
                      '&:hover': { color: 'gold' },
                    }}
                  >
                    <i className="fab fa-instagram"></i>
                  </Typography>
                  <Typography
                    component="a"
                    href="#"
                    sx={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '1.5rem',
                      '&:hover': { color: 'gold' },
                    }}
                  >
                    <i className="fab fa-youtube"></i>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

export default Contact;
